"use strict";

var _construct = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var utils_1 = require("../../utils");

var FlagSet_1 = require("../FlagSet");

var parserSupport_1 = require("./parserSupport");

var ValidationResult_1 = require("./ValidationResult");
/**
 * Abstract interface of classes that convert any value to target type.
 * Meaning of such conversion is implementation dependent but each parser
 * have at least provide 'identity conversion' - i.e. if provided value is
 * of same type as target type, parser returns the value.
 * @param <T> target type
 */


var Parser =
/*#__PURE__*/
function () {
  function Parser() {
    _classCallCheck(this, Parser);
  }

  _createClass(Parser, null, [{
    key: "failure",
    value: function failure(msg) {
      return new (
      /*#__PURE__*/
      function (_Parser) {
        _inherits(_class, _Parser);

        function _class() {
          _classCallCheck(this, _class);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
        }

        _createClass(_class, [{
          key: "parse",
          value: function parse(input, level) {
            return new ValidationResult_1.ValidationError(msg || 'This parser always fails');
          }
        }]);

        return _class;
      }(Parser))();
    }
  }]);

  return Parser;
}();

exports.Parser = Parser;

var StringParser =
/*#__PURE__*/
function (_Parser2) {
  _inherits(StringParser, _Parser2);

  function StringParser() {
    _classCallCheck(this, StringParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringParser).apply(this, arguments));
  }

  _createClass(StringParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (typeof input === 'object') return parserSupport_1.badType(input, 'string');
      if (typeof input === 'string') return parserSupport_1.succ(input);
      if (!input) return parserSupport_1.badType(input, 'string');
      return parserSupport_1.succ(input.toString());
    }
  }]);

  return StringParser;
}(Parser);

exports.StringParser = StringParser; // same as StringParser but also trims the string

var StringTrimParser =
/*#__PURE__*/
function (_Parser3) {
  _inherits(StringTrimParser, _Parser3);

  function StringTrimParser() {
    _classCallCheck(this, StringTrimParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringTrimParser).apply(this, arguments));
  }

  _createClass(StringTrimParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (typeof input === 'object') return parserSupport_1.badType(input, 'string');
      if (typeof input === 'string') return parserSupport_1.succ(input.trim());
      if (!input) return parserSupport_1.badType(input, 'string');
      return parserSupport_1.succ(input.toString().trim());
    }
  }]);

  return StringTrimParser;
}(Parser);

exports.StringTrimParser = StringTrimParser; // tslint:disable-next-line:ban-types

var StringMapParser =
/*#__PURE__*/
function (_Parser4) {
  _inherits(StringMapParser, _Parser4);

  function StringMapParser() {
    _classCallCheck(this, StringMapParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringMapParser).apply(this, arguments));
  }

  _createClass(StringMapParser, [{
    key: "parse",
    value: function parse(input, level) {
      Object.keys(input).forEach(function (key) {
        if (typeof input[key] !== 'string') {
          return parserSupport_1.badType(input, 'string');
        }
      });
      return parserSupport_1.succ(input.toString());
    }
  }]);

  return StringMapParser;
}(Parser);

exports.StringMapParser = StringMapParser;

var StringNumberMapParser =
/*#__PURE__*/
function (_Parser5) {
  _inherits(StringNumberMapParser, _Parser5);

  function StringNumberMapParser() {
    _classCallCheck(this, StringNumberMapParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(StringNumberMapParser).apply(this, arguments));
  }

  _createClass(StringNumberMapParser, [{
    key: "parse",
    value: function parse(input, level) {
      Object.keys(input).forEach(function (key) {
        if (typeof input[key] !== 'string' || typeof input[key] !== 'number') {
          return parserSupport_1.badType(input, 'string or number');
        }
      });
      return parserSupport_1.succ(input.toString());
    }
  }]);

  return StringNumberMapParser;
}(Parser);

exports.StringNumberMapParser = StringNumberMapParser;

var EnumParser =
/*#__PURE__*/
function (_Parser6) {
  _inherits(EnumParser, _Parser6);

  function EnumParser(enumObject) {
    var _this;

    _classCallCheck(this, EnumParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EnumParser).call(this));
    _this.enumObject = enumObject;
    return _this;
  }

  _createClass(EnumParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (!input) return parserSupport_1.badType(input, 'string');
      if (typeof input === 'object') return parserSupport_1.badType(input, 'string');

      if (typeof input === 'string') {
        var vals = this.getValues();
        return !vals[input] ? parserSupport_1.badEnum(input, this.enumObject) : parserSupport_1.succ(input);
      }

      return parserSupport_1.succ(input.toString());
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this2 = this;

      var vals = EnumParser.enumValues.get(this.enumObject);

      if (vals) {
        return vals;
      }

      var ret = {};
      Object.keys(this.enumObject).forEach(function (k) {
        return ret[_this2.enumObject[k]] = true;
      });
      EnumParser.enumValues.set(this.enumObject, ret);
      return ret;
    }
  }]);

  return EnumParser;
}(Parser);

exports.EnumParser = EnumParser;
EnumParser.enumValues = new WeakMap();

var NumberParser =
/*#__PURE__*/
function (_Parser7) {
  _inherits(NumberParser, _Parser7);

  function NumberParser() {
    _classCallCheck(this, NumberParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberParser).apply(this, arguments));
  }

  _createClass(NumberParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (typeof input === 'number') return parserSupport_1.succ(input);

      if (typeof input === 'string') {
        try {
          var standardizedInput = input.replace(',', '.').replace(/\s/g, '');

          if (isNaN(Number(standardizedInput))) {
            return parserSupport_1.badType(input, 'number');
          }

          return parserSupport_1.succ(Number(standardizedInput));
        } catch (err) {
          return parserSupport_1.badType(input, 'number');
        }
      }

      return parserSupport_1.badType(input, 'number');
    }
  }]);

  return NumberParser;
}(Parser);

exports.NumberParser = NumberParser;

var BigNumberParser =
/*#__PURE__*/
function (_Parser8) {
  _inherits(BigNumberParser, _Parser8);

  function BigNumberParser() {
    _classCallCheck(this, BigNumberParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(BigNumberParser).apply(this, arguments));
  }

  _createClass(BigNumberParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (input instanceof big_decimal_1.BigDecimal) {
        return parserSupport_1.succ(input);
      }

      if (typeof input === 'number') {
        return parserSupport_1.succ(big_decimal_1.bigdecimal(input));
      }

      if (typeof input === 'string') {
        try {
          var standardizedInput = input.replace(',', '.');
          return parserSupport_1.succ(big_decimal_1.bigdecimal(standardizedInput));
        } catch (err) {
          return parserSupport_1.badType(input, 'big number');
        }
      }

      return parserSupport_1.badType(input, 'big number');
    }
  }]);

  return BigNumberParser;
}(Parser);

exports.BigNumberParser = BigNumberParser;

var BooleanParser =
/*#__PURE__*/
function (_Parser9) {
  _inherits(BooleanParser, _Parser9);

  function BooleanParser() {
    _classCallCheck(this, BooleanParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(BooleanParser).apply(this, arguments));
  }

  _createClass(BooleanParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (typeof input === 'boolean') return parserSupport_1.succ(input);

      if (typeof input === 'string') {
        if (input === 'true' || input === '1') {
          return parserSupport_1.succ(true);
        }

        if (input === 'false' || input === '0') {
          return parserSupport_1.succ(false);
        }

        return parserSupport_1.badType(input, 'boolean');
      }

      return parserSupport_1.badType(input, 'boolean');
    }
  }]);

  return BooleanParser;
}(Parser);

exports.BooleanParser = BooleanParser;

var FlagSetParser =
/*#__PURE__*/
function (_Parser10) {
  _inherits(FlagSetParser, _Parser10);

  function FlagSetParser(base) {
    var _this3;

    _classCallCheck(this, FlagSetParser);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FlagSetParser).call(this));
    _this3.base = base;
    return _this3;
  }

  _createClass(FlagSetParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (!utils_1.Utils.isArray(input)) return parserSupport_1.badType(input, 'flag array');

      try {
        var set = new FlagSet_1.FlagSet(this.base);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var it = _step.value;
            set.addDeserialized(it);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return parserSupport_1.succ(set);
      } catch (err) {
        return new ValidationResult_1.ValidationError(parserSupport_1.INVALID_FLAG_SET, err.message);
      }
    }
  }]);

  return FlagSetParser;
}(Parser);

exports.FlagSetParser = FlagSetParser;

function input2Object(input) {
  if (utils_1.Utils.isObject(input)) {
    return new ValidationResult_1.ValidationSuccess(input);
  }

  if (utils_1.Utils.isString(input)) {
    try {
      return new ValidationResult_1.ValidationSuccess(JSON.parse(input));
    } catch (err) {
      return new ValidationResult_1.ValidationError(err);
    }
  }

  return utils_1.Utils.isObject(input) ? new ValidationResult_1.ValidationSuccess(input) : parserSupport_1.unsupported(input);
}

var ObjectParser =
/*#__PURE__*/
function (_Parser11) {
  _inherits(ObjectParser, _Parser11);

  function ObjectParser() {
    _classCallCheck(this, ObjectParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectParser).call(this));
  }

  _createClass(ObjectParser, [{
    key: "parse",
    value: function parse(input, level) {
      return input2Object(input);
    }
  }]);

  return ObjectParser;
}(Parser);

exports.ObjectParser = ObjectParser;

function object2desc(input, desc, level) {
  var obj = input2Object(input);

  if (!obj.valid) {
    return obj;
  }

  var inp = obj.value;
  var ret = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Object.getOwnPropertyNames(desc)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var validatedPropName = _step2.value;
      var onePropValidationResult = desc[validatedPropName].validate(inp[validatedPropName], level);

      if (!onePropValidationResult.valid) {
        return _construct(ValidationResult_1.ValidationError, [onePropValidationResult.messageKey, validatedPropName].concat(_toConsumableArray(onePropValidationResult.messageArgs)));
      }

      ret[validatedPropName] = onePropValidationResult.value;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return new ValidationResult_1.ValidationSuccess(ret);
}

var DataDescParser =
/*#__PURE__*/
function (_Parser12) {
  _inherits(DataDescParser, _Parser12);

  function DataDescParser(desc) {
    var _this4;

    _classCallCheck(this, DataDescParser);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(DataDescParser).call(this));
    _this4.desc = desc;
    return _this4;
  }

  _createClass(DataDescParser, [{
    key: "parse",
    value: function parse(input, level) {
      return object2desc(input, this.desc, level);
    }
  }]);

  return DataDescParser;
}(Parser);

exports.DataDescParser = DataDescParser;

var ObjectDescParser =
/*#__PURE__*/
function (_Parser13) {
  _inherits(ObjectDescParser, _Parser13);

  function ObjectDescParser(desc, xform) {
    var _this5;

    _classCallCheck(this, ObjectDescParser);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ObjectDescParser).call(this));
    _this5.desc = desc;
    _this5.xform = xform;
    return _this5;
  }

  _createClass(ObjectDescParser, [{
    key: "parse",
    value: function parse(input, level) {
      var mat = object2desc(input, this.desc, level);

      if (!mat.valid) {
        return mat;
      }

      try {
        return new ValidationResult_1.ValidationSuccess(this.xform(mat.value));
      } catch (err) {
        return new ValidationResult_1.ValidationError(err);
      }
    }
  }]);

  return ObjectDescParser;
}(Parser);

exports.ObjectDescParser = ObjectDescParser;